import '../../common/bn-map';
import '../../common/bn-map-marker';
import { css, html, LitEntity, SirenActionMixin } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';

const config = JSON.parse(import.meta.env.VITE_PROJECT_AWS_SSM_CONFIG);

class BinLocation extends SirenActionMixin(LitEntity) {
  constructor() {
    super();
    this.interactive = false;
  }

  static get properties() {
    return {
      longitude: { type: Number, attribute: false },
      latitude: { type: Number, attribute: false },
      interactive: { type: Boolean, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
      bn-map {
        height: 100%;
      }

      .static-map {
        position: relative;
        width: 100%;
        height: 100%;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        cursor: pointer;
      }

      .static-map-overlay {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.6);
        opacity: 0;
        transition: all 0.2s ease 0s;
        font-size: 2rem;
        color: #FFFFFF;
      }

      .static-map-overlay:hover {
        opacity: 1;
      }

      .static-map-marker {
        position: absolute;
        left: calc(50% - 13px);
        top: calc(50% - 36px);
        width: 26px;
        height: 36px;
        background-size: contain;
        background-position: center;
        background-image: url('/images/map_marker_binsentry_blue.png');
      }
    `];
  }

  render() {
    if (this.latitude === undefined || this.longitude === undefined) {
      return html``;
    }

    if (!this.interactive) {
      // Google static maps cost WAY less money than interactive maps, so we require the user to click to enable the
      // interactive map on the Bin details page.
      return html`
        <div class="static-map"
             style="background-image: url(${this._getStaticUrl(this.latitude, this.longitude)})"
             @click="${this._onStaticMapClick}"
        >
          <div class="static-map-marker"></div>
          <div class="static-map-overlay"><div>Click to Interact</div></div>
        </div>
      `;
    }

    return html`
      <bn-map
        id="map"
        zoom="18"
        .scaleControl="${false}"
        .rotateControl="${false}"
        .streetViewControl="${false}"
        .zoomControl="${false}"
        .mapTypeControl="${false}"
      >
        <bn-map-marker .latitude="${this.latitude}" .longitude="${this.longitude}"></bn-map-marker>
      </bn-map>
    `;
  }

  fitMarkers() {
    const bnMap = this.renderRoot.querySelector('bn-map');
    bnMap && bnMap.fitMarkers();
  }

  async _entityChanged(entity) {
    super._entityChanged(entity);
    this.latitude = this.getProperty('location.latitude');
    this.longitude = this.getProperty('location.longitude');

    await this.updateComplete;
    this.fitMarkers();
  }

  _onStaticMapClick() {
    this.interactive = true;
  }

  _getStaticUrl(lat, long) {
    const key = config['google_maps_key'];
    return `https://maps.googleapis.com/maps/api/staticmap?${new URLSearchParams({
      key,
      zoom: 18,
      center: `${lat},${long}`,
      maptype: 'satellite',
      size: '1280x1280',
      scale: 2,
    }).toString()}`;
  }
}

window.customElements.define('bin-location', BinLocation);
